import { atom } from 'recoil';

import type { IArticlesState } from './type';

export const ArticlesState = atom<IArticlesState>({
  key: 'articles-list-state',
  default: {
    articles: [],
    loading: true,
  },
});
